import type React from "react";

import { Route, Routes } from "react-router-dom";

import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";

import { PatientProfile, PatientsList } from "./views";

export const PatientsRoutes: React.FC = () => {
  const offsetTop = usePageContentOffsetTop();

  return (
    <Routes>
      <Route path=":patientId/*" element={<PatientProfile />} />
      <Route
        path="/"
        element={
          <Container $pageContentOffsetTop={offsetTop}>
            <PatientsList />
          </Container>
        }
      />
    </Routes>
  );
};
